import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';
import config from './config';
import '../Styles/Inquiry.css'; // Import the CSS file
import ChatBot from "./ChatBot";

const Inquiry = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [category, setCategory] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${config.backendUrl}/api/inquiry`, { name, phone, email, category, message });
      alert('Inquiry sent successfully');
      // Reset the form fields
      setName('');
      setPhone('');
      setEmail('');
      setCategory('');
      setMessage('');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className='inquiry'>
    <div className="inquiry-container" data-aos="fade-down">
      <h2>Send Inquiry</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name:</label>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>phone:</label>
          <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Email:</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Category:</label>
          <input type="text" value={category} onChange={(e) => setCategory(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Message:</label>
          <textarea value={message} onChange={(e) => setMessage(e.target.value)} required />
        </div>
        <button type="submit">Send Inquiry</button>
      </form>
    </div>
    <ChatBot />
    </div>
  );
};

export default Inquiry;
// import React, { useState } from 'react';
// import axios from 'axios';
// import config from "./config";

// const Inquiry = () => {
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [category, setCategory] = useState('');
//   const [message, setMessage] = useState('');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await axios.post(`${config.backendUrl}/api/inquiry`, { name, email, category, message });
//       alert('Inquiry sent successfully');
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   return (
//     <div>
//       <h2>Send Inquiry</h2>
//       <form onSubmit={handleSubmit}>
//         <div>
//           <label>Name:</label>
//           <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
//         </div>
//         <div>
//           <label>Email:</label>
//           <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
//         </div>
//         <div>
//           <label>Category:</label>
//           <input type="text" value={category} onChange={(e) => setCategory(e.target.value)} required />
//         </div>
//         <div>
//           <label>Message:</label>
//           <textarea value={message} onChange={(e) => setMessage(e.target.value)} required />
//         </div>
//         <button type="submit">Send Inquiry</button>
//       </form>
//     </div>
//   );
// };

// export default Inquiry;
